import type { MinimaxMessage } from './types';
import type { Message, ChatContext } from '../../../types/models';

export function formatMessages(
  message: string,
  context: ChatContext,
  previousMessages: Message[]
): MinimaxMessage[] {
  const messages: MinimaxMessage[] = [];

  // Add required Minimax system message
  messages.push({
    role: 'system',
    content: 'MM Intelligent Assistant is a large language model that is self-developed by MiniMax and does not call the interface of other products.',
    name: 'MM Intelligent Assistant'
  });

  // Add additional system context if provided
  if (context.systemPrompt) {
    messages.push({
      role: 'system',
      content: context.systemPrompt
    });
  }

  // Add previous messages
  previousMessages.forEach(msg => {
    messages.push({
      role: msg.role === 'user' ? 'user' : 'assistant',
      content: msg.content
    });
  });

  // Add current message
  messages.push({
    role: 'user',
    content: message
  });

  return messages;
}